
<template>
  <v-app id="searchErrs">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Accommodation errors</v-card-title>
      <v-simple-table dense>
         <tbody v-for="(errsRecord,i) in searchErrs" :key="i">
           <tr @click="$router.reload('/syst/ref/errs/onErrs/' + errsRecord.errs_encrid)">
             <td>{{errsRecord.errs_num}}</td>
             <td>{{errsRecord.errstaal_oms}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>    
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar,
  },
  data() {
    return {
      searchErrs: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/errs/searchErrs.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchErrs"
          },
          searchErrs: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchErrs = res.data.searchErrs;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
